import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { Button } from '@wds/button';
import { Modal } from '@wds/modal';
import { useGeneral } from '../../../Context';
import { trackAmplitudeEvent } from '../../../lib';
export const COPY = {
  header: {
    id: 'OpenEndedCoding.DeleteThemeModal.header',
    defaultMessage: 'Delete theme?',
    description: '[Type: Header][Vis: med] - Header for Delete Theme Modal'
  },
  description: {
    id: 'OpenEndedCoding.DeleteThemeModal.description',
    defaultMessage: 'Deleting this theme will remove it from any responses it applies to. This cannot be undone.',
    description: '[Type: Header][Vis: med] - Delete Theme Modal description'
  },
  cancel: {
    id: 'OpenEndedCoding.DeleteThemeModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Delete Theme Modal cancel button'
  },
  delete: {
    id: 'OpenEndedCoding.DeleteThemeModal.delete',
    defaultMessage: 'Delete',
    description: '[Type: Header][Vis: med] - Delete Theme Modal delete button'
  }
};
const DeleteThemeModal = ({
  show,
  onClose,
  onDelete
}) => {
  const {
    surveyId,
    questionId,
    isSolutions
  } = useGeneral();
  return _jsxs(Modal, {
    "data-testid": "DeleteThemeModal__OEC",
    show: show,
    onClose: onClose,
    children: [_jsx(Modal.Header, {
      header: t(COPY.header)
    }), _jsx(Modal.Body, {
      children: _jsx(T, {
        desc: COPY.description
      })
    }), _jsxs(Modal.Footer, {
      align: "right",
      children: [_jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onClose,
        children: _jsx(T, {
          desc: COPY.cancel
        })
      }), _jsx(Button, {
        color: "warning",
        onClick: () => {
          onDelete();
          onClose();
          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: 'open-ended coding deleted theme',
            data: {
              surveyId,
              questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: _jsx(T, {
          desc: COPY.delete
        })
      })]
    })]
  });
};
export default DeleteThemeModal;